module.exports = __webpack_public_path__ + "img/poor-kid-v1.03a28834.jpg";